import React from 'react';
import { subscriptionHasCredits } from '../../helpers/subscriptionHelpers';
import { QuestionIcon } from '../../modules/Icons';
import { Tooltip } from 'react-tooltip';
import BuyWithCredits from './BuyWithCredits';
import { MainLinkButton } from '../styled/buttons/MainLinkButton';

const CartSubscriptionBlock: React.FC<any> = (props) => {
  const {
    collection,
    product,
    subscription,
    modifiedPrice,
    selectedVariant,
    variantPrices,
    user,
    hideOr,
    isOpen
  } = props;

  return (
    <>
      {/* Note: Do not show unlocks for 3D libraries, per Ro (library_id=3), or for contributor libraries */}
      <div>
        {modifiedPrice > 0 &&
          !isOpen &&
          subscriptionHasCredits(subscription) &&
          collection?.library?.id != 3 &&
          !collection?.contributor?.id && (
            <>
              <BuyWithCredits
                subscription={subscription}
                variant={selectedVariant}
                user={user}
                variantPrices={variantPrices}
              />
            </>
          )}
      </div>
    </>
  );
};

export default CartSubscriptionBlock;
